export const OperacionLEPFields = {
    CodOperacionLEPEstado: 'codOperacionLEPEstado',
    DescOperacionLEPEstado: 'descOperacionLEPEstado',
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    FechaAprobacion: 'fechaAprobacion',
    FechaVencimiento: 'fechaVencimiento',
    CodUnidadNegocio: 'codUnidadNegocio',
    UnidadNegocio: 'descUnidadNegocio',
    CodSectorComercial: 'codSectorComercial',
    SectorComercial: 'descSectorComercial',
    FechaAprobacionFinal: 'fechaAprobacionFinal',
    FechaAlta: 'fechaAlta',
    IdUsuarioAlta: 'idUsuarioAlta',
    NombreUsuarioAlta: 'nombreUsuarioAlta',
    ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
    MailUsuarioAlta: 'mailUsuarioAlta',
    FechaUltMod: 'fechaUltMod',
    IdUsuarioUltMod: 'idUsuarioUltMod',
    EstadoFinalizado: 'estadoFinalizado',
    PermiteEditarOperacion: 'permiteEditarOperacion',
    PermiteEliminarOperacion: 'permiteEliminarOperacion',
    PermiteAgregarEmisores: 'permiteAgregarEmisores',
    IdMensaje: 'idMensaje',
    Emisores: 'emisores'
} as const;

export const OperacionLEPEmisorFields = {
    RazonSocial: 'razonSocial',
    CodOperacionLEPEmisorTipo: 'codOperacionLEPEmisorTipo',
    DescOperacionLEPEmisorTipo: 'descOperacionLEPEmisorTipo',
    PermiteEditar: 'permiteEditar'
} as const;

export const OperacionLEPTituloFields = {
    Id: 'id',
    Descripcion: 'descripcion', // El DTO base EntidadCacheIntIdDTO mapea vchTitulo a Descripcion
    CodSistema: 'codSistema',
    Titulo: 'titulo',
    IdEtapa: 'idEtapa',
    Activo: 'activo',
    Inicial: 'inicial'
} as const;

export const OperacionLEPUnidadNegocioFields = {
    Tipo: 'unidadNegocioTipo'
} as const;